export const style = {
  Box: {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      height: '100%',
      color: 'primary.text',
      '& .MuiTypography-root': {
        color: 'primary.text',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: 120,
      },
      '& svg': {
        fontSize: '24px',
      },
      position: 'relative',
      cursor: 'default',
    },
  },
  Typography: {
    sx: {
      fontWeight: '600',
      color: 'action.active',
      '& + .error-tooltip': {
        display: 'none',
      },
      '&:hover + .error-tooltip': {
        position: 'absolute',
        bottom: '120%',
        right: 0,
        display: 'block',
        width: '250px',
        backgroundColor: '#130F35',
        color: '#fff',
        borderRadius: 1,
        height: 'auto',
        boxShadow: '0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)',
        padding: '8px 16px',
      },
    },
  },
  color: {
    sx: {
      color: 'action.active',
      fontWeight: 300,
    },
  },
} as const;
